export default "##### Area Visits\n---\n- Created by actively tracking mobile phones across the US (billions of location signals per day)";